import { render, staticRenderFns } from "./ProlongTender.vue?vue&type=template&id=247935fa&scoped=true"
import script from "./ProlongTender.vue?vue&type=script&lang=js"
export * from "./ProlongTender.vue?vue&type=script&lang=js"
import style0 from "./ProlongTender.vue?vue&type=style&index=0&id=247935fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247935fa",
  null
  
)

export default component.exports